/**
 * Error thrown for every failed API call. Mirrors the backend's RFC 9457 problem+json body.
 * `code` is stable and safe to branch on (e.g. 'BOOKING_SLOT_TAKEN').
 */
export class ApiError extends Error {
  constructor({ status, code, title, detail, errors = [], requestId = null }, options) {
    super(detail || title || `Request failed (${status})`, options)
    this.name = 'ApiError'
    this.status = status
    this.code = code
    this.title = title
    this.errors = errors
    this.requestId = requestId
  }

  /** Field-level messages keyed by field name, for React Hook Form `setError`. */
  get fieldErrors() {
    return Object.fromEntries(this.errors.filter((e) => e.field).map((e) => [e.field, e.message]))
  }
}

export const isApiError = (err) => err instanceof ApiError
